<template>
  <div id="app">
    <router-view />
    <component-modals />
  </div>
</template>

<script>

import componentModals from '@/components/Modals'


export default {
  name: 'App',
  components: {
    componentModals
  },
  computed: {
    visibleModalEditPhrase: function() {
      return this.$store.state.activeModal === 'modalEditPhrase'
    }
  },
}
</script>
<style scoped>
@import url('https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/4.2.1/css/bootstrap.min.css');
</style>
